//TMF Archieve

export const GENERATE_COMPLETE_AUDIT_TRAIL = "GENERATE_COMPLETE_AUDIT_TRAIL";
export const GET_COMPLETE_AUDIT_TRAIL = "GET_COMPLETE_AUDIT_TRAIL";
export const DOWNLOAD_COMPLETE_AUDIT_TRAIL = "DOWNLOAD_COMPLETE_AUDIT_TRAIL";
export const SET_INITIAL_AUDIT_CANCEL = "SET_INITIAL_AUDIT_CANCEL";

//EMF Archieve

export const GENERATE_COMPLETE_EMS_TRAIL = "GENERATE_COMPLETE_EMS_TRAIL";
export const GET_COMPLETE_EMS_TRAIL = "GET_COMPLETE_EMS_TRAIL";
export const DOWNLOAD_COMPLETE_EMS_TRAIL = "DOWNLOAD_COMPLETE_EMS_TRAIL";
export const SET_INITIAL_ARCHIVE_CANCEL = "SET_INITIAL_ARCHIVE_CANCEL";

//Loader

export const SHOW_LOADER = "SHOW_LOADER";
export const HIDE_LOADER = "HIDE_LOADER";
export const SHOW_ERROR = "SHOW_ERROR";
export const HIDE_ERROR = "HIDE_ERROR";

//Time

export const GET_TIME_FORMAT = "GET_TIME_FORMAT";

//TMF Admin Status

export const GET_LOCK_STATUS = "GET_LOCK_STATUS";
export const SET_ETMF_LOCK = "SET_ETMF_LOCK";
export const SET_ETMF_UNLOCK = "SET_ETMF_UNLOCK";
export const GET_CLIENT_DETAILS = "GET_CLIENT_DETAILS";
export const GET_REFRESH_TOKEN = "GET_REFRESH_TOKEN";

//TMF Admin Settings

export const GET_ENABLING_MILESTONE_STATUS = "GET_ENABLING_MILESTONE_STATUS";
export const UPDATING_ENABLING_MILESTONE_STATUS =
  "UPDATING_ENABLING_MILESTONE_STATUS";
export const CLEAR_SETTING_TOASTER_MESSAGE = "CLEAR_SETTING_TOASTER_MESSAGE";
export const GET_DOCU_TEMPLATE_NAMES = "GET_DOCU_TEMPLATE_NAMES";

//USER
export const GET_STUDY_INFO = "GET_STUDY_INFO";
export const GET_ORG_ID = "GET_ORG_ID";
export const GET_ROLE_LIST = "GET_ROLE_LIST";
export const GET_USER_LIST = "GET_USER_LIST";
export const GET_USER_INFO = "GET_USER_INFO";
export const FETCH_ALL_CLIENT_APIS = "FETCH_ALL_CLIENT_APIS";
export const GO_TO_BROWSER_VIEW = "GO_TO_BROWSER_VIEW";
export const FETCH_ROLE_LIST_VIEW = "FETCH_ROLE_LIST_VIEW";
export const STUDY_INFO_DB_CHECK = "STUDY_INFO_DB_CHECK";
//TMF Structure

export const MAINTENANCE_ON_OFF = "MAINTENANCE_ON_OFF";
export const MAINTENANCE_STATUS = "MAINTENANCE_STATUS";

export const GET_TMF_STRUCTURE_CHANGES = "GET_TMF_STRUCTURE_CHANGES";
export const REVERT_STRUCTURE_CHANGES = "REVERT_STRUCTURE_CHANGES";
export const APPLY_STRUCTURE_CHANGES = "APPLY_STRUCTURE_CHANGES";

export const TMF_STRUCTURE_DATA = "TMF_STRUCTURE_DATA";

export const GET_MILESTONE_COUNT = "GET_MILESTONE_COUNT";

export const GET_TMF_STRUCTURE = "GET_TMF_STRUCTURE";
export const SAVE_TMF_STRUCTURE = "SAVE_TMF_STRUCTURE";
export const GET_MILESTONE_LIST = "GET_MILESTONE_LIST";
export const GET_MILESTONE_ARTIFACT_COUNT = "GET_MILESTONE_ARTIFACT_COUNT";

export const GET_MILESTONE_INFO_LIST = "GET_MILESTONE_INFO_LIST";
export const GET_MILESTONE_VIEW_HANDLER = "GET_MILESTONE_VIEW_HANDLER";
export const GET_COUNTRY_LIST = "GET_COUNTRY_LIST";
export const GET_SITE_LIST = "GET_SITE_LIST";
export const GET_MILESTONE_DROPDOWN_DATA = "GET_MILESTONE_DROPDOWN_DATA";
export const GET_MILESTONE_GROUP = "GET_MILESTONE_GROUP";
export const GET_ZONE_SECTION = "GET_ZONE_SECTION";
export const SELECTED_FILTER_ID = "SELECTED_FILTER_ID";
export const GET_VIEW_ZONE_SEC_ARTIF = "GET_VIEW_ZONE_SEC_ARTIF";
export const GET_DATING_CONVENTION_LIST = "GET_DATING_CONVENTION_LIST";
export const ADD_NEW_ARTIFACT = "ADD_NEW_ARTIFACT";
export const DELETE = "DELETE";
export const ADD_NEW_MILESTONE = "ADD_NEW_MILESTONE";
export const EDIT_MILESTONE = "EDIT_MILESTONE";
export const CHANGE_MILESTONE_SEQUENCE = "CHANGE_MILESTONE_SEQUENCE";
export const DELETE_MILESTONE = "DELETE_MILESTONE";
export const CLEAR_STRUCTURE_EDIT_CHANGES = "CLEAR_STRUCTURE_EDIT_CHANGES";

//Documents
export const GET_DOCUMENT_BY_SECTION = "GET_DOCUMENT_BY_SECTION";
export const GET_DOCUMENT_BY_ARTIFACT = "GET_DOCUMENT_BY_ARTIFACT";
export const GET_SHARED_DOCUMENT = "GET_SHARED_DOCUMENT";
export const GET_SELECTED_DOCUMENT_DETAIL = "GET_SELECTED_DOCUMENT_DETAIL";
export const GET_SELECTED_DOCUMENT_HISTORY = "GET_SELECTED_DOCUMENT_HISTORY";
export const GET_DOCUMENT_VERSION_LIST = "GET_DOCUMENT_VERSION_LIST";
export const FETCH_DOCUMENT_MASTER = "FETCH_DOCUMENT_MASTER";
export const FETCH_DOCUMENT_DELETE = "FETCH_DOCUMENT_DELETE";
export const FETCH_DOCUMENT_LOCK = "FETCH_DOCUMENT_LOCK";
export const GET_UPDATED_DOC_LIST = "GET_UPDATED_DOC_LIST";
export const GET_DOCUMENT_CONTENT_DETAILS = "GET_DOCUMENT_CONTENT_DETAILS";
export const CLEAR_DOCUMENT_VERSION_LIST = "CLEAR_DOCUMENT_VERSION_LIST";
export const CLONE_DOC_NEW_VERSION = "CLONE_DOC_NEW_VERSION";

export const DOCUMENT_STATUS_CHANGE = "DOCUMENT_STATUS_CHANGE";
export const DOCUMENT_STATUS_IN_PROGRESS = "DOCUMENT_STATUS_IN_PROGRESS";
export const DOCUMENT_STATUS_CHANGE_FAILED = "DOCUMENT_STATUS_CHANGE_FAILED";
export const DOCUMENT_STATUS_CHANGE_SUCCESS = "DOCUMENT_STATUS_CHANGE_SUCCESS";
export const DOCUMENT_STATUS_SAVE_REVIEW = "DOCUMENT_STATUS_SAVE_REVIEW";
export const DOCUMENT_STATUS_GET_REVIEW = "DOCUMENT_STATUS_GET_REVIEW";
export const ARTIFACT_REMOVED = "ARTIFACT_REMOVED";
export const ARTIFACT_ITEM_REMOVED = "ARTIFACT_ITEM_REMOVED";
export const FILTER_DOCUMENTS = "FILTER_DOCUMENTS";
export const GET_CUSTOMIZED_COLSTATE = "GET_CUSTOMIZED_COLSTATE";
export const SAVE_CUSTOMIZED_COLSTATE = "SAVE_CUSTOMIZED_COLSTATE";
export const CLEAR_DOCERROR_MESSAGE = "CLEAR_DOCERROR_MESSAGE";
export const CLEAR_FILEERROR_MESSAGE = "CLEAR_FILEERROR_MESSAGE";
export const FETCH_LOAD_DOCUMENT_MASTER = "FETCH_LOAD_DOCUMENT_MASTER";
export const IS_DOCUMENT_STATUS_CHANGE_HISTORY = "IS_DOCUMENT_STATUS_CHANGE_HISTORY"

//File Download
export const FILE_DOWNLOAD_URL = "FILE_DOWNLOAD_URL";
export const FILE_DOWNLOAD_URL_FAILED = "FILE_DOWNLOAD_URL_FAILED";
export const FILE_DOWNLOAD_URL_SUCCESS = "FILE_DOWNLOAD_URL_SUCCESS";
export const IS_DOWNLOADING = "IS_DOWNLOADING";
export const FILE_PREVIEW_URL = "FILE_PREVIEW_URL";

//Metrics
export const FETCH_METRICS_DATA = "FETCH_METRICS_DATA";
export const FETCH_ZONE_DATA = "FETCH_ZONE_DATA";

//File Scanning
export const SCANNING_PROCESS_STATUS = "SCANNING_PROCESS_STATUS";

//Azure file upload
export const FILE_UPLOAD = "FILE_UPLOAD";
export const FILE_UPLOAD_FAILED = "FILE_UPLOAD_FAILED";
export const FILE_UPLOAD_SUCCESS = "FILE_UPLOAD_SUCCESS";
export const FILE_UPLOAD_PROGRESS = "FILE_UPLOAD_PROGRESS";
export const CANCEL_UPLOAD_DATA = "CANCEL_UPLOAD_DATA";
export const CANCEL_UPLOAD = "CANCEL_UPLOAD";

export const STUDY_INFO = "STUDY_INFO";
export const REMOVE_INVALID_DOCUMENT = "REMOVE_INVALID_DOCUMENT";
export const CREATE_NEW_DOC_VERSION = "CREATE_NEW_DOC_VERSION";
export const SINGLE_FILE_PROGRESSING = "SINGLE_FILE_PROGRESSING";
export const SINGLE_FILE_ERROR_TOASTER = "SINGLE_FILE_ERROR_TOASTER";

//AppInit
export const GET_APP_INIT_CONFIG = "GET_APP_INIT_CONFIG";

//Zones and Sections
export const GET_COUNTRY_SITE_LIST = "GET_COUNTRY_SITE_LIST";
export const EDIT_ZONE = "EDIT_ZONE";
export const EDIT_SECTION = "EDIT_SECTION";
export const CLEAR_CHANGES_FOUND = "CLEAR_CHANGES_FOUND";
export const SHOW_ZONE_LOADER = "SHOW_ZONE_LOADER";
export const HIDE_ZONE_LOADER = "HIDE_ZONE_LOADER";
export const TO_PASS_MODIFIED_FILE_DATA = "TO_PASS_MODIFIED_FILE_DATA";
export const CANCEL_DOC_ID = "CANCEL_DOC_ID";
export const RECORD_STATE = "RECORD_STATE";
export const DOC_NEW_VERSION_XFDF_STRING = "DOC_NEW_VERSION_XFDF_STRING";
export const UPLOADED_NEW_VERSION_FILE = "UPLOADED_NEW_VERSION_FILE";
export const CLEAR_DOCUMENT_DATA_LIST = "CLEAR_DOCUMENT_DATA_LIST"

//DropZone
export const GET_DROP_ZONE_DATA = "GET_DROP_ZONE_DATA";
export const GET_DROP_ZONE_SETTING = "GET_DROP_ZONE_SETTING";
export const SET_DROP_ITEMS = "SET_DROP_ITEMS";
export const DO_DROP_ZONE_FILESCREENING_STATUS =
  "DO_DROP_ZONE_FILESCREENING_STATUS";
export const GET_DROP_ZONE_FILESCREENING_STATUS =
  "GET_DROP_ZONE_FILESCREENING_STATUS";
export const RESET_PROGRESS_FILE_DATA = "RESET_PROGRESS_FILE_DATA";
export const SET_INVALID_FILE_ERROR = "SET_INVALID_FILE_ERROR";
export const REMOVE_INVALID_DOC = "REMOVE_INVALID_DOC";
export const DO_SAVE_TMF_DROP_ZONE = "DO_SAVE_TMF_DROP_ZONE";
export const DELETE_DROPZONE = "DELETE_DROPZONE";
export const REMOVE_DELETE_DOC = "REMOVE_DELETE_DOC";
//Template
export const TEMPLATE_FILE_SCREENING_STATUS = "TEMPLATE_FILE_SCREENING_STATUS";
export const IS_CANCEL_TEMPLATE = "IS_CANCEL_TEMPLATE";
export const FETCH_ALL_TEMPLATES = "FETCH_ALL_TEMPLATES";
export const EXPORT_TEMPLATE = "EXPORT_TEMPLATE";
export const DELETE_TEMPLATE = "DELETE_TEMPLATE";
export const TEMPLATE_IMPORT = "TEMPLATE_IMPORT";
export const TEMPLATE_IMPORT_FAILED = "TEMPLATE_IMPORT_FAILED";
export const TEMPLATE_IMPORT_SUCCESS = "TEMPLATE_IMPORT_SUCCESS";
export const RENAME_TEMPLATE = "RENAME_TEMPLATE";
export const SELECT_TEMPLATE = "SELECT_TEMPLATE";
export const INSTANTIATE_TEMPLATE = "INSTANTIATE_TEMPLATE";

//Document Notes
export const ADD_DOC_NOTE = "ADD_DOC_NOTE";
export const CLEAR_DOC_NOTE = "CLEAR_DOC_NOTE";
export const GET_DOC_NOTE = "GET_DOC_NOTE";
export const RESOLVE_DOC_NOTE = "RESOLVE_DOC_NOTE";

//Sharing
export const GET_ADMIN_SHARING_SETTING = "GET_ADMIN_SHARING_SETTING";
export const GET_SHARING_METRICS_BY_VERSION = "GET_SHARING_METRICS_BY_VERSION";
export const GET_EXISTING_SHARED_USER_LIST = "GET_EXISTING_SHARED_USER_LIST";
export const IS_BINDERS_CALL_RUNNING = "IS_BINDERS_CALL_RUNNING";
export const GET_DOC_SHARE_USER_LIST = "GET_DOC_SHARE_USER_LIST";
export const CLEAR_BINDER_METRICS = "CLEAR_BINDER_METRICS";
export const GET_SHARED_FILE_COUNT = "GET_SHARED_FILE_COUNT";
export const UPDATE_USER_SHARED_LIST = "UPDATE_USER_SHARED_LIST";
export const GET_BINDERS_DETAIL = "GET_BINDERS_DETAIL";
export const CREATE_NEW_BINDER_FOR_SHARING = "CREATE_NEW_BINDER_FOR_SHARING";
export const GET_BINDERS_HISTORY = "GET_BINDERS_HISTORY";
export const DOWNLOAD_SIGNATURE_DETAILS = "DOWNLOAD_SIGNATURE_DETAILS";
export const RECALL_BINDER = "RECALL_BINDER";
export const SHOW_DOWNLOAD_LOADER = "SHOW_DOWNLOAD_LOADER";
export const SHOW_BINDER_DETAIL_PAGE = "SHOW_BINDER_DETAIL_PAGE";
export const DOWNLOAD_SHARING_DETAILS = "DOWNLOAD_SHARING_DETAILS";
export const GET_DOWNLOAD_SHARING_STATUS = "GET_DOWNLOAD_SHARING_STATUS";
export const DOWNLOAD_SIGNATURE_ZIP_DETAILS = "DOWNLOAD_SIGNATURE_ZIP_DETAILS";
export const DOWNLOAD_WITH_NOTES = "DOWNLOAD_WITH_NOTES";

//AG GRID

export const REMOVE_AG_GRID_LIST = "REMOVE_AG_GRID_LIST";

//eTMF Tracking

export const ETMF_TRACKING = "ETMF_TRACKING";